import React, { useContext, useEffect, useState } from "react";
import EstoreBannerImg from "../../assets/images/new/E-Storebanner.png";
import Breadcrumbs from "../Breadcrumb";
import faq2 from "../../assets/images/omnamo/faq2.png";
import train from "../../assets/images/new/train.png";
import bus from "../../assets/images/new/bus.png";
import aeroplane from "../../assets/images/new/aeroplane.png";
import temple from "../../assets/images/new/temple-hindu.png";
import { useNavigate, useLocation } from "react-router-dom";

import "./templeDetails.css";
import {
  AuthContextProvider,
  LoaderContext,
} from "../../AuthContext/AuthContext";
import DownloadApp from "../DownLoadApp/DownloadApp";
import LoginPopUp from "../LoginPopup";
import batuk from "../../assets/images/new/fav-removebg-preview.png";
import { TempleDetailsBySlug } from "../../ApiServices/Temple/TempleApi";
import { Prev } from "react-bootstrap/esm/PageItem";
import VideoModal from "../VideoPlayer";
import { Helmet } from "react-helmet-async";
const TempleDetails = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [activeCategory, setActiveCategory] = useState(1);
  const navigate = useNavigate();
  const { isAuthenticated } = useContext(AuthContextProvider);
  const [loginPopUp, setLoginPopUp] = useState(false);
  const [showVideoModal, setShowVideoModal] = useState(false);
  const [categories, setCategories] = useState([]);
  const [templeDetails, setTempleDetails] = useState(null);
  const [travelByList, setTravelByList] = useState([]); // Add this line
  const { setLoader, loader } =
    useContext(LoaderContext);
  const location = useLocation();
  const { slug } = location.state || {}; // Extract slug from state
  const [modelRequestData, setModelRequestData] = useState({
    Action: null,
    DARSHAN_PRICE: null,
    DARSHAN_TIME: null,
    TR_ID: null,
    CONVENIENCE_FEE: null,
    TR_SHORTDETAILS: null,
  });

  const demoData = {
    Action: null,
    DARSHAN_PRICE: 1000,
    DARSHAN_TIME: "10 AM",
    TR_ID: 1,
    CONVENIENCE_FEE: 100,
    TR_SHORTDETAILS: "temple",

    BEST_SEASON: "ABC",
    CONVENIENCE_FEE: 10,
    DARSHAN_PRICE: 1000,
    DARSHAN_TIME: "12 pm",
    LATITUDE: 0,
    LONGITUDE: 0,
    Row: 1,
    SEATING_CAPACITY: 10,
    TR_ADDRESS: "Nasik",
    TR_DETAILS: "ABC",
    TR_ID: 123,
    TR_IMAGE: faq2,
    TR_NAME: "Shani",
    TR_RULES: "Descipline",
    TR_SHORTDETAILS: "Nashik",
  };
  const DemoPujaAtTempleData = {
    Action: null,
    Row: 1,
    PAT_ID: 123,
    PAT_NAME: "Ganpati Mandir",
    PAT_PRICE: 1000,
    PAT_CONVENIENCEFEE: 15,
    PAT_IMAGE: faq2,
    PAT_ADDRESS: "nashik",
    PAT_DETAILS: "ABC",
    PAT_SAMAGRI: "ABC",
    PAT_SAMAGRIPRICE: 250,
    PAT_TAC: "ABC",
    DARSHAN_PRICE: 2000,
    DARSHAN_TIME: "10 AM",
    TR_ID: 10,
    CONVENIENCE_FEE: 15,
    TR_SHORTDETAILS: "ABC",
  };

  useEffect(() => {
    setCategories([
      { value: 1, label: "Overview", ID: "#" },
      { value: 2, label: "Temple Timings", ID: "templeTimingsSection" },
      { value: 3, label: "Location", ID: "templeLocationSection" },
    ]);
  }, []);
  useEffect(() => {

    if (slug !== undefined && slug !== '' && slug !== null) {
      fetchTempleDetails(slug);
    } else {
      navigate('/page-not-found')
    }
  }, [slug]);
  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const handleDarshanBooking = () => {
    setModelRequestData({
      ...modelRequestData,
    });
    if (isAuthenticated) {
      navigate(`/temple/${templeDetails.DarshanBookingSlug}`);
    } else {
      setLoginPopUp(true);
    }
  };

  const handlePujaAtTemple = () => {
    if (isAuthenticated) {
      navigate(`/puja-at-temple/${templeDetails.PoojaAtTempleSlug}`);
    } else {
      setLoginPopUp(true);
    }
  };



  const fetchTempleDetails = async (slug) => {

    setLoader(true)
    try {
      const response = await TempleDetailsBySlug(slug); // Call your API with the slug
      if (response?.ResponseCode === "0") {
        setLoader(false)

        setTempleDetails(response.DATA); // Access DATA directly as an object

        // Set travelByList based on the response
        const { ByAir, ByTrain, ByRoad } = response.DATA;
        setTravelByList([
          {
            title: "By Air",
            description: ByAir || "No information available.",
          },
          {
            title: "By Train",
            description: ByTrain || "No information available.",
          },
          {
            title: "By Road",
            description: ByRoad || "No information available.",
          },
        ]);
      }
    } catch (error) {
      setLoader(false)
      console.error("Error fetching temple details:", error);
    }
  };
  const handleLiveDarshanClicked = () => {
    setShowVideoModal(true)
  }

  const articleSchema = {
    "@context": "https://schema.org",
    "@type": "Article",
    "headline": templeDetails?.MetaTitle,
    "description": templeDetails?.MetaDescription,
    "image": templeDetails?.imageURL || "default-image-url.jpg",
    "author": {
      "@type": "Organization",
      "name": "Myomnamo",
      "url": "https://www.myomnamo.com"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Myomnamo",
      "logo": {
        "@type": "ImageObject",
        "url": "https://www.myomnamo.com"
      }
    },
    "datePublished": templeDetails?.publishedDate || null,
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": templeDetails?.canonicalURL
    }
  };

  const webPageSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": templeDetails?.MetaTitle,
    "description": templeDetails?.MetaDescription,
    "url": templeDetails?.CanonicalTag,
    "image": templeDetails?.imageURL || "default-image-url.jpg",
    "inLanguage": "en",
    "publisher": {
      "@type": "Organization",
      "name": "Myomnamo",
      "url": `https://www.myomnamo.com/${templeDetails?.TempleSlug}`
    }
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://www.myomnamo.com"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "List",
        "item": "https://www.myomnamo.com/temple"
      },
      {
        "@type": "ListItem",
        "position": 3,
        "name": templeDetails?.MetaTitle,
        "item": templeDetails?.canonicalURL
      }
    ]
  };
  console.log(templeDetails, 'templeDetails')
  const mapUrl = `https://www.google.com/maps?q=${templeDetails?.Latitude},${templeDetails?.Longitude}&z=15&output=embed`;
  return (
    <>
      <Helmet>
        {/* Meta Title & Description */}
        <title>{templeDetails?.MetaTitle}</title>

        {/* Meta description */}
        <meta name="description" content={templeDetails?.MetaDescription} />
        {/* Breadcrumb JSON-LD Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify(breadcrumbSchema)}
        </script>

        {/* WebPage JSON-LD Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify(webPageSchema)}
        </script>

        <script type="application/ld+json">
          {JSON.stringify(articleSchema)}
        </script>

      </Helmet>

      <section className="page-header">
        <div
          className="page-header__bg"
          style={{ backgroundImage: `url(${EstoreBannerImg})` }}
        ></div>
        <div className="container">
          <h2 className="page-header__title bw-split-in-left">
            {templeDetails ? templeDetails.TempleName : " "}
          </h2>
        </div>
      </section>
      <div style={{ paddingLeft: "5em" }}>
        <Breadcrumbs />
      </div>
      <div data-js="hero-demo">
        <ul class="grid-temple">
          <li class="element-item-temple cat-1" data-category="cat-1">
            <section class="about-one-temple about-one-temple--about">
              {/* Images & Details */}
              <div class="container">
                <div class=" g-0 align-items-center" style={{ width: '100%' }}>
                  <div class="col-xl-12 pe-0 card" style={{ border: "none", marginTop: '10px' }}>
                    {/* <!-- No padding on the right --> */}
                    <div className="image-grid-container">
                      <div className="left-image">
                        {templeDetails &&
                          templeDetails.TempleImages &&
                          templeDetails.TempleImages.length > 0 ? (
                          <img
                            src={templeDetails.TempleImages[0]}
                            alt="Main Temple"
                          />
                        ) : loader === false ? (
                          <img src={faq2} alt="Main" />
                        ) : ''}
                      </div>
                      {templeDetails?.TempleImages?.length === 3 && (
                        <div className="right-images layout-3">
                          {templeDetails?.TempleImages?.slice(1).map((image, index) => (
                            <img
                              key={index}
                              src={image}
                              alt={`Temple Image ${index + 2}`}
                            />
                          ))}
                        </div>
                      )}

                      {templeDetails?.TempleImages?.length === 4 && (
                        <div className="right-images layout-4">
                          {templeDetails?.TempleImages?.slice(1).map((image, index) => (
                            <img
                              key={index}
                              src={image}
                              alt={`Temple Image ${index + 2}`}
                              className={`right-image ${index === 1 ? 'full-width' : ''}`}
                            />
                          ))}
                        </div>
                      )}


                      {templeDetails?.TempleImages?.length === 2 && (
                        <div className="right-images" style={{ display: "block" }}>
                          {templeDetails &&
                            templeDetails?.TempleImages &&
                            templeDetails?.TempleImages?.slice(1).map(
                              (image, index) => (
                                <img
                                  key={index}
                                  src={image}
                                  alt={`Temple Image ${index + 2}`} // Adjust index for alt text
                                />
                              )
                            )}
                        </div>
                      )}
                      {templeDetails?.TempleImages?.length === 5 && (
                        <div className="right-images layout-5">
                          {templeDetails?.TempleImages?.slice(1).map((image, index) => (
                            <img
                              key={index}
                              src={image}
                              alt={`Temple Image ${index + 2}`}
                              className="right-image"
                            />
                          ))}
                        </div>
                      )}


                    </div>
                  </div>

                  {/* <!-- Right Column: Content --> */}
                  <div
                    class="col-xl-12 ps-0 wow fadeInRight mt-5"
                    data-wow-delay="200ms"
                  >
                    {/* <!-- No padding on the left --> */}
                    <div class="about-one__content-temple">
                      {/* <div class="sec-title-temple text-center">

                                                <h3 class="main-head-temple">

                                                </h3>
                                            </div> */}
                      <div class=" text-center">
                        <h6 className="sec-title__tagline bw-split-in-right text-center">
                          <img className=" tagline-img" src={batuk} alt="" />
                          Temple Details
                        </h6>
                        <h3 class="sec-title__title-temple bw-split-in-left text-center">
                          {templeDetails ? templeDetails.TempleName : " "}
                        </h3>
                      </div>

                      <p>
                        {templeDetails
                          ? templeDetails?.MetaDescription?.replace(
                            /<[^>]+>/g,
                            ""
                          ) // Remove HTML tags
                          : "Temple Name Not Available..."}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              {/* Services Buttons  */}
              <div class="ui-group">
                <div class="filters-temple button-group js-radio-button-group device-type">
                  {/* <!-- <button class="button is-checked" data-filter="*">All</button> --> */}
                  {templeDetails?.DarshanBookAvailable && (
                    <button
                      class="download-app-btn  "
                      data-filter=".cat-1"
                      onClick={() => handleDarshanBooking()}
                    >
                      Darshan Booking{" "}
                    </button>
                  )}
                  {templeDetails?.PoojaAtTempleAvailable && (
                    <button
                      class="download-app-btn"
                      data-filter=".cat-3"
                      onClick={() => {
                        handlePujaAtTemple();
                      }}
                    >
                      Puja At Temple{" "}
                    </button>
                  )}

                  {templeDetails?.PrasadBookingAvailable && (
                    <button
                      className="download-app-btn"
                      data-filter=".cat-2"
                      onClick={() => {
                        // navigate("/prasad-list");
                        navigate("/prasad-list", { state: { ID: templeDetails?.TempleID } })
                      }}
                    >
                      Prasad Booking
                    </button>
                  )}
                  {templeDetails?.LiveDarshanAvailable && (
                    <button className="download-app-btn" onClick={() => handleLiveDarshanClicked()} data-filter=".cat-2">
                      Live Darshan
                    </button>
                  )}

                </div>
              </div>

              {/* Tabs  */}
              <div className="category-tabs-container">
                <ul
                  className="nav justify-content-center border-bottom"
                  style={{ margin: "15px" }}
                >
                  {categories.map((cat, idx) => (
                    <li className="nav-item " key={idx}>
                      <button
                        className={`nav-link-blog category-tab-btn ${activeCategory === cat.value ? "active" : "InActive"
                          } `}
                        style={{ fontSize: "medium" }}
                        onClick={() => {
                          setActiveCategory(cat?.value);
                          const section = document.getElementById(cat?.ID);
                          if (section) {
                            const offset = 150; // Adjust scroll offset (e.g., for sticky header)
                            const topPos =
                              section.getBoundingClientRect().top +
                              window.pageYOffset -
                              offset;
                            window.scrollTo({
                              top: topPos,
                              behavior: "smooth",
                            });
                          }
                        }}
                      >
                        {cat.label}
                      </button>
                    </li>
                  ))}
                </ul>
                <br></br>
                {/* Optional: filtered content placeholder */}
                {/* <div className="mt-3">
            Showing results for: <strong>{activeCategory}</strong>
          </div> */}
              </div>
            </section>

            {/* Temple Details */}
            <section class="about-one-temple about-one-temple--about">
              <div class="container">
                <div class="row g-4 align-items-center px-3">
                  {/* <!-- Left Column --> */}
                  <div class="col-xl-12 wow fadeInLeft" data-wow-delay="200ms">
                    <div class="about-one__content-temple p-1  shadow rounded bg-light h-100">
                      <div class="text-center  ">
                        <h6 className="sec-title__tagline mt-4 bw-split-in-right">
                          <img className=" tagline-img" src={batuk} alt="" />
                          Significance of the Temple
                        </h6>

                        {/* <div class="about-one__image__one mb-3">
                                                    <img class="main-imgs-temple img-fluid rounded" src={faq2}
                                                        alt="Significance of the Temple" />
                                                </div> */}
                        {/* <p>
                          {templeDetails
                            ? templeDetails?.SignificanceOfTheTemple?.replace(
                              /<[^>]+>/g,
                              ""
                            )
                            : "Temple Name Not Available..."}
                        </p> */}
                        <div
                          dangerouslySetInnerHTML={{
                            __html: templeDetails?.SignificanceOfTheTemple,
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  {/* <!-- Right Column --> */}
                  <div class="col-xl-12 wow fadeInRight" data-wow-delay="400ms">
                    <div class="about-one__content-temple p-1 shadow rounded bg-light h-100">
                      <div class="text-center">
                        <h6 className="sec-title__tagline mt-4 bw-split-in-right">
                          <img className=" tagline-img" src={batuk} alt="" />
                          Architecture of the Temple
                        </h6>
                        {/* <h3 class="sec-title__title-temple fw-bold  mb-4">
                                                    Architecture of the Temple
                                                </h3> */}
                        {/* <div class="about-one__image__one mb-3">
                                                    <img class="main-imgs-temple img-fluid rounded" src={faq2}
                                                        alt="Architecture of the Temple" />
                                                </div> */}
                        {/* <p>
                          {templeDetails
                            ? templeDetails?.ArchitectureOfTheTemple?.replace(
                              /<[^>]+>/g,
                              ""
                            )
                            : "Temple Name Not Available..."}
                        </p> */}
                        <div
                          dangerouslySetInnerHTML={{
                            __html: templeDetails?.ArchitectureOfTheTemple,
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </li>

          {/* Time Section */}
          <li
            id="templeTimingsSection"
            class="element-item-temple cat-2"
            data-category="cat-2"
            style={{ margin: '10px ' }}
          >
            <section class="about-one-temple about-one-temple--about">
              <div class="container">
                <div class="row g-4 align-items-center px-3">
                  {/* <!-- Left Column --> */}
                  <div class="col-xl-12 wow fadeInLeft" data-wow-delay="200ms">
                    <div class="about-one__content-temple p-2  shadow rounded bg-light h-100">
                      <div className="text-center ">
                        {/* <h3 class="fw-bold mb-4" style={{ textAlign: 'center', color: '#a52444' }}>Temple Timings</h3> */}
                        <h6
                          className="sec-title__tagline mt-4 text-center"
                          style={{ justifyContent: "center" }}
                        >
                          <img className=" tagline-img" src={batuk} alt="" />
                          Temple Timings
                        </h6>
                        <div class="row g-4">
                          {/* <!-- Timing Card --> */}
                          <div class="col-md-6">
                            <div class="timing-card-temple d-flex align-items-center shadow-sm p-3 rounded bg-white">
                              <div class="icon-circle-temple me-3">
                                <img src={temple} />

                              </div>
                              <div>
                                <h6 class="mb-1 fw-semibold">Opening time</h6>
                                <p class="mb-0 text-muted">
                                  {" "}
                                  {templeDetails ? templeDetails.OpeningTiming : " "}
                                </p>
                              </div>
                            </div>
                          </div>

                          <div class="col-md-6">
                            <div class="timing-card-temple d-flex align-items-center shadow-sm p-3 rounded bg-white">
                              <div class="icon-circle-temple me-3">
                                <img src={temple} />
                              </div>
                              <div>
                                <h6 class="mb-1 fw-semibold">Closing time</h6>
                                <p class="mb-0 text-muted">
                                  {" "}
                                  {templeDetails ? templeDetails.ClosingTiming : " "}
                                </p>
                              </div>
                            </div>
                          </div>

                          {/* <!-- Repeat for other timing entries... --> */}
                          {/* <div class="col-md-6">
                    <div class="timing-card-temple d-flex align-items-center shadow-sm p-3 rounded bg-white">
                      <div class="icon-circle-temple me-3">
                        <img src={faq2} alt="aarti" class="icon-img-temple" />
                      </div>
                      <div>
                        <h6 class="mb-1 fw-semibold">Morning bhog timings</h6>
                        <p class="mb-0 text-muted">06:30 AM - 07:00 AM</p>
                      </div>
                    </div>
                  </div> */}

                          {/* <div class="col-md-6">
                    <div class="timing-card-temple d-flex align-items-center shadow-sm p-3 rounded bg-white">
                      <div class="icon-circle-temple me-3">
                        <img src={faq2} alt="aarti" class="icon-img-temple" />
                      </div>
                      <div>
                        <h6 class="mb-1 fw-semibold">
                          Morning darshan Aarti timings
                        </h6>
                        <p class="mb-0 text-muted">08:30 AM - 11:30 AM</p>
                      </div>
                    </div>
                  </div> */}

                          {/* <div class="col-md-6">
                    <div class="timing-card-temple d-flex align-items-center shadow-sm p-3 rounded bg-white">
                      <div class="icon-circle-temple me-3">
                        <img src={faq2} alt="aarti" class="icon-img-temple" />
                      </div>
                      <div>
                        <h6 class="mb-1 fw-semibold">Morning Bhog timings</h6>
                        <p class="mb-0 text-muted">11:30 AM - 12:00 PM</p>
                      </div>
                    </div>
                  </div> */}

                          {/* <div class="col-md-6">
                    <div class="timing-card-temple d-flex align-items-center shadow-sm p-3 rounded bg-white">
                      <div class="icon-circle-temple me-3">
                        <img
                          src={faq2}
                          alt="calendar"
                          class="icon-img-temple"
                        />
                      </div>
                      <div>
                        <h6 class="mb-1 fw-semibold">Temple evening timings</h6>
                        <p class="mb-0 text-muted">04:30 PM - 08:30 PM</p>
                      </div>
                    </div>
                  </div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </li>
          <li class="element-item-temple cat-3"
            data-category="cat-3"
          >
            {/* <section class="about-one-temple about-one-temple--about">
              <div class="container">
                <div class="row g-0 align-items-center">

                  <div
                    class="col-xl-12 ps-0 wow fadeInRight"
                    data-wow-delay="200ms"
                  >

                    <div class="about-one__content-temple" style={{ margin: '25px 10px 25px 10px' }}>
                      <section className="faq-one faq-one--page" style={{ backgroundColor: '#f8f9fa', padding: '25px 0 7px' }}>
                        <div
                          className="container"
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <h6
                            className="sec-title__tagline text-center"
                            style={{ justifyContent: "center" }}
                          >
                            <img className=" tagline-img" src={batuk} alt="" />
                            How To Reach ?
                          </h6>
                          <div className="row">
                            <div className="col-xl-12">
                              <div className="faq-one__accordion careox-accordion">
                                {travelByList.map((faq, index) => (
                                  <div
                                    key={index}
                                    className={`accrodion ${activeIndex === index ? "active" : ""
                                      }`}
                                    style={{ "--accent-color": faq.color, boxShadow: '1px 2px grey', backgroundColor: 'white' }}
                                  >
                                    <div
                                      className="accrodion-title"
                                      onClick={() => toggleFAQ(index)}
                                    >
                                      <h4>
                                        <span
                                          className="accrodion-title__number"
                                          style={{
                                            marginRight: "10px",
                                            fontWeight: "500",
                                          }}
                                        ></span>
                                        {faq.title}
                                        <span className="accrodion-title__icon"></span>
                                      </h4>
                                    </div>
                                    <div
                                      className="accrodion-content"
                                      style={{
                                        maxHeight:
                                          activeIndex === index ? "200px" : "0",
                                        overflow: "hidden",
                                        transition:
                                          "max-height 0.5s ease-in-out",
                                      }}
                                    >
                                      <div className="inner">
                                        <p>{faq.description}</p>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                    </div>
                  </div>
                </div>
              </div>
            </section> */}
            <section class="py-4 text-center bg-light">
              {/* <h2 class="mb-5 text-danger fw-bold">
                🙏 How To Reach?
              </h2> */}
              <h6
                className="sec-title__tagline text-center"
                style={{ justifyContent: "center" }}
              >
                <img className=" tagline-img" src={batuk} alt="" />
                How To Reach ?
              </h6>
              <div class="container">
                <div class="row g-4 justify-content-center">


                  <div class="col-md-4">
                    <div class="card p-4 h-100 rounded-4 shadow-sm border-0">
                      <div
                        className="mx-auto mb-3 rounded-circle d-flex align-items-center justify-content-center"
                        style={{
                          width: "90px",
                          height: "90px",
                          border: '1px solid black',
                          borderRadius: 'rounded'
                          // backgroundColor: "#007bff", // Use bg-primary, bg-success, bg-warning for others
                        }}
                      >
                        <img
                          src={aeroplane}
                          alt="air"
                          style={{
                            width: "50px",
                            height: "50px",
                            objectFit: "contain",
                          }}
                        />
                      </div>
                      <h5 class="fw-bold">By Air</h5>
                      <p class="text-muted" style={{ color: 'black' }}>
                        {travelByList[0]?.description}
                      </p>
                    </div>
                  </div>


                  <div class="col-md-4">
                    <div class="card p-4 h-100 rounded-4 shadow-sm border-0">
                      <div
                        className="mx-auto mb-3  rounded-circle d-flex  align-items-center justify-content-center"
                        style={{
                          width: "90px",
                          height: "90px",
                          border: '1px solid black',
                          borderRadius: 'rounded'
                        }}
                      >
                        <img
                          src={train}
                          alt="train"
                          style={{
                            width: "50px",
                            height: "50px",
                            objectFit: "contain",
                          }}
                        />
                      </div>
                      <h5 class="fw-bold">By Train</h5>
                      <p class="text-muted" style={{ color: 'black' }}>
                        {travelByList[1]?.description}
                      </p>
                    </div>
                  </div>


                  <div class="col-md-4">
                    <div class="card p-4 h-100 rounded-4 shadow-sm border-0">
                      <div
                        className="mx-auto mb-3 rounded-circle  d-flex  align-items-center justify-content-center"
                        style={{
                          width: "90px",
                          height: "90px",
                          border: '1px solid black',
                          borderRadius: 'rounded'
                        }}
                      >
                        <img
                          src={bus}
                          alt="air"
                          style={{
                            width: "50px",
                            height: "50px",
                            objectFit: "contain",
                          }}
                        />
                      </div>
                      <h5 class="fw-bold"> By Road</h5>
                      <p class="text-muted" style={{ color: 'black' }}>
                        {travelByList[2]?.description}
                      </p>
                    </div>
                  </div>

                </div>
              </div>
            </section>
          </li>
        </ul>
        {/* Traveling Details section  */}
        <ul className="grid-temple-location" id="templeLocationSection" style={{ width: '100%' }}>
          <li
            class="element-item-temple cat-3"
            data-category="cat-3"
            id="templeLocationSection"
          >
            <section className="travel-details-section-temple pt-5">
              <div className="text-center">
                <h6 className="sec-title__tagline bw-split-in-right">
                  <img className="tagline-img" src={batuk} alt="" />
                  Temple Map Details
                </h6>
                <p className="mb-4">
                  The below are the travel details for the temple
                </p>

                <iframe
                  src={mapUrl}
                  width="1000"
                  height="450"
                  style={{ border: "0", width: "100%" }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Temple Location Map"
                ></iframe>
              </div>
            </section>

          </li>

        </ul>


        {/* Download App Section  */}
        {/* <div class=" text-center">
                    <h6 className="sec-title__tagline bw-split-in-right">
                        <img className=" tagline-img" src={batuk} alt="" />
                       Download App 
                    </h6>

                </div> */}
        <DownloadApp />
      </div>
      {showVideoModal && (
        <VideoModal show={showVideoModal} onHide={() => setShowVideoModal(false)} videoUrl={templeDetails?.LiveDarshanURL} />
      )}
      {loginPopUp && (
        <LoginPopUp show={loginPopUp} onHide={() => setLoginPopUp(false)} />
      )}
    </>
  );
};

export default TempleDetails;